import { downloadBase64File } from "../../../../../common/utils/download_utils";
import { ReportMimeType } from "../../../../../common/utils/report_callback";
import { IGetReportChecklistAreaUseCase } from "../../../presentation/useCases/read/get_report_checklist_area_use_case";
import { ReportData } from "../../models/report_data";
import { IReportsRepository } from "../../repositories/reports_repository";

import dayjs from "dayjs";

/**
 * GetReportChecklistAreaUseCase
 */

export class GetReportChecklistAreaUseCase implements IGetReportChecklistAreaUseCase {
  constructor(private readonly repository: IReportsRepository) { }

  async getReportChecklistArea(
    requiredMimeType: ReportMimeType | null,
    idInspecaoObra: number,
  ): Promise<ReportData> {
    const response = await this.repository.getReportChecklistArea(
      requiredMimeType,
      idInspecaoObra,
    );

    if (response.mimeType !== 'text/html') {
      const temporaryFilename = `checklist_area_${dayjs(new Date()).format('DD_MM_YYYY_HH_mm_ss')}.${response.filenameExtension}`;

      const arquivoNome = response.filename === null || response.filename === undefined || response.filename.trim() === '' ||
        response.filenameExtension === null || response.filenameExtension === undefined || response.filenameExtension.trim() === ''
        ? temporaryFilename
        : `${response.filename}.${response.filenameExtension}`;

      const arquivo = response.bytes;

      await downloadBase64File(arquivoNome, arquivo);
    }
    return response;
  }
}
